import CryptoJS from 'crypto-js';

export const generateSignature = (request, key, secret) => {
  if (!request || !key || !secret) {
    throw new Error('Invalid input: request, key, and secret are required.');
  }

  const ts = Number.parseInt(new Date().getTime(), 10);

  let nonce = '';
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < 36; i += 1) {
    nonce += charset.charAt(Math.floor(Math.random() * charset.length));
  }

  const { method, url, data } = request;

  if (!method || !url) {
    throw new Error('Invalid request: method and url are required.');
  }

  const payload = data && data.length > 0 ? data : '';

  const index = url.split('/');
  const index1 = index[2].split(':');

  const host = index1[0];
  const port = index1.length > 1 ? index1[1] : '443';

  const resourceUri = index1.length > 1
    ? url.slice(Math.max(0, url.indexOf(host) + host.length + port.length + 1))
    : url.slice(Math.max(0, url.indexOf(host) + host.length));

  try {
    const hashPayload = CryptoJS.HmacSHA256(payload, secret);
    const hashBase64Payload = CryptoJS.enc.Base64.stringify(hashPayload);

    const macInput = `${ts}\n${nonce}\n${method}\n${resourceUri}\n${host}\n${port}\n${hashBase64Payload}\n`;
    const hashMac = CryptoJS.HmacSHA256(macInput, secret);
    const hashBase64Mac = CryptoJS.enc.Base64.stringify(hashMac);

    const signature = `MAC id="${key}",ts="${ts}",nonce="${nonce}", bodyhash="${hashBase64Payload}", mac="${hashBase64Mac}"`;

    return signature;
  } catch (error) {
    throw new Error(`Error generating signature: ${error.message}`);
  }
};
